/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Group_HelpInputs */

const en_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an existing group or create a new one`)
};

const fr_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un groupe existant ou creez-en un nouveau`)
};

const de_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine bestehende Gruppe aus oder erstellen Sie eine neue.`)
};

const it_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un gruppo esistente o creane uno nuovo`)
};

const ru_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите существующую группу или создайте новую.`)
};

const es_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija un grupo existente o cree uno nuevo`)
};

const zh_cn2_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择现有群组或创建新群组`)
};

const ja_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存のグループを選択するか、新しいグループを作成します`)
};

const hi_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी मौजूदा समूह को चुनें या एक नया समूह बनाएं`)
};

const pt_pt2_marker_import_group_help = /** @type {(inputs: Marker_Import_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um grupo existente ou crie um novo.`)
};

/**
* | output |
* | --- |
* | "Choose an existing group or create a new one" |
*
* @param {Marker_Import_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_group_help = /** @type {((inputs?: Marker_Import_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_group_help(inputs)
	if (locale === "de") return de_marker_import_group_help(inputs)
	if (locale === "it") return it_marker_import_group_help(inputs)
	if (locale === "ru") return ru_marker_import_group_help(inputs)
	if (locale === "es") return es_marker_import_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_group_help(inputs)
	if (locale === "ja") return ja_marker_import_group_help(inputs)
	if (locale === "hi") return hi_marker_import_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_group_help(inputs)
	return en_marker_import_group_help(inputs)
});